<template>
  <span class="svg-ico-arrow-right">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4279 5.48282C15.1423 5.18284 14.6676 5.17121 14.3676 5.45684C14.0676 5.74247 14.056 6.2172 14.3416 6.51718L18.8479 11.2499H4.59766C4.18344 11.2499 3.84766 11.5857 3.84766 11.9999C3.84766 12.4141 4.18344 12.7499 4.59766 12.7499H18.8481L14.3416 17.4828C14.056 17.7828 14.0676 18.2575 14.3676 18.5432C14.6676 18.8288 15.1423 18.8172 15.4279 18.5172L21.1409 12.5172C21.4167 12.2275 21.4167 11.7725 21.1409 11.4828L15.4279 5.48282Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
